(function() {
  'use strict';

  angular.module('wml.portal.404', []);

})();
